import { List } from 'immutable'
import 'whatwg-fetch'
import { AsyncState, httpResult, listFromOption, loadingAsyncState } from 'widgets-for-react'
import { canSafelyCast, TypeCastingValidator } from '../../../Shared/Frontend/validators/casting-validation'
import { TeamMember, TeamMembersODataResponse } from './aboutUs.state'

export async function getRawTeamMembers(): Promise<Array<any>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/teamMembers`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = (await res.json()) as TeamMembersODataResponse
  return json
}

const teamMemberValidator: TypeCastingValidator<TeamMember, keyof TeamMember> = {
  Name: { kind: 'string' },
  Surname: { kind: 'string' },
  CompanyRole: { kind: 'string' },
  ImageURL: { kind: 'string' },
  Id: { kind: 'string' },
  Age: { kind: 'number', customValidationLogic: (age: number) => age >= 0 && age <= 150 }
}

export function loadTeamMembers(): AsyncState<Array<TeamMember>> { 
  return loadingAsyncState(() =>
    getRawTeamMembers().then((raw) =>
      httpResult.success(
        List(raw)
          .map((v) => {
            return canSafelyCast<TeamMember>(teamMemberValidator, v)
          })
          .flatMap<TeamMember>(listFromOption)
          .toArray()
      )
    )
  )
}